import React from 'react';
import PropTypes from 'prop-types';
import {
  Entrar as EntrarView
} from '../../views/Painel';


const VerificaAltenticacao = props => {
  const { children } = props;

  // Se não estiver logado chama página de login
  if (window.localStorage.getItem('planos_t') == null ||
    window.localStorage.getItem('planos_u') == null ||
    window.localStorage.getItem('planos_y') == null ||
    window.localStorage.getItem('planos_n') == null ||
    window.localStorage.getItem('planos_i') == null) {
    return (
      <EntrarView />
    );
  }
  else {
    return (
      <div>
        {children}
      </div>
    );
  }
};

VerificaAltenticacao.propTypes = {
  children: PropTypes.node
};

export default VerificaAltenticacao;
